import { render } from "./MainBerita.vue?vue&type=template&id=3e1807f4"
import script from "./MainBerita.vue?vue&type=script&lang=js"
export * from "./MainBerita.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__